export default {
    md:"1rem"
 
  };